import { Block } from "../types";

// Import all block definitions
import { cardHeaderBlock } from "./CardHeaderBlock";
import { themeBlock } from "./ThemeBlock";
import { trendBlock } from "./TrendBlock";
import { keyMetricsBlock } from "./KeyMetricsBlock";
import { insightsBlock } from "./InsightsBlock";
import { attentionBlock } from "./AttentionBlock";
import { topActivitiesBlock } from "./TopActivitiesBlock";
import { workPatternsBlock } from "./WorkPatternsBlock";
import { notableContributorsBlock } from "./NotableContributorsBlock";
import { classificationAnalysisBlock } from "./ClassificationAnalysisBlock";
import { outliersBlock } from "./OutliersBlock";
import { distributionAnalysisBlock } from "./DistributionAnalysisBlock";
import { groupAnalysisBlock } from "./GroupAnalysisBlock";
import { correlationAnalysisBlock } from "./CorrelationAnalysisBlock";
import { summaryBlock } from "./SummaryBlock";
import { trendAnalysisBlock } from "./TrendAnalysisBlock";
import { footerBlock } from "./FooterBlock";
import { tagBlock } from "./TagBlock";
import { keyMetricChangeBlock } from "./KeyMetricChangeBlock";
import { resourcesBlock } from "./ResourcesBlock";
import { investmentSummaryBlock } from "./InvestmentSummaryBlock";
import { queryBlock } from "./QueryBlock";
import { activitiesBlock } from "./ActivitiesBlock";
// Export all blocks
export const INITIAL_BLOCKS: Record<string, Block> = {
  activities: activitiesBlock,
  attention: attentionBlock,
  "card-header": cardHeaderBlock,
  "classification-analysis": classificationAnalysisBlock,
  "correlation-analysis": correlationAnalysisBlock,
  "distribution-analysis": distributionAnalysisBlock,
  footer: footerBlock,
  "group-analysis": groupAnalysisBlock,
  insights: insightsBlock,
  "investment-summary": investmentSummaryBlock,
  "key-metrics": keyMetricsBlock,
  "key-metric-change": keyMetricChangeBlock,
  "notable-contributors": notableContributorsBlock,
  outliers: outliersBlock,
  query: queryBlock,
  resources: resourcesBlock,
  summary: summaryBlock,
  tag: tagBlock,
  theme: themeBlock,
  "top-activities": topActivitiesBlock,
  trend: trendBlock,
  "trend-analysis": trendAnalysisBlock,
  "work-patterns": workPatternsBlock,
};

// Export the base block creator
export { createBaseBlock } from "./BaseBlock";
